import { memo, useMemo } from 'react';
import useCollections from '../Hooks/useCollections';
import useHelpers from '../Hooks/useHelpers';
import useTarifs from '../Hooks/useTarifs';
import styles from './CardModel.module.scss';
import DynImage from './DynImage';
import { faStars } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CardModel = memo(function CardModel(props: { id: string; onClick?: (id: string) => void; inactive?: boolean; small?: boolean }) {
   const { getModelById, isHJOModel, isExcluBoutique } = useCollections();
   const { getMinMaxPriceForModel } = useTarifs();
   const { formatPPUPrice } = useHelpers();

   const model = useMemo(() => getModelById(props.id), [getModelById, props.id])

   const minMax = useMemo(() => {
      const mm = getMinMaxPriceForModel(model?.id)
      return mm.reason ? { min: 0, max: 0 } : mm
   }, [getMinMaxPriceForModel, model?.id])

   const addClasses = `${props.inactive ? ' ' + styles.inactive : ''}${props.small ? ' ' + styles.small : ''}`

   return (
      <button
         className={`${styles.card_model}${addClasses}`}
         onClick={() => props.onClick?.(props.id)}
      >
         {model && (
            <DynImage
               className={styles.imgmodel}
               src={[`catalogue/modeles/${model.id}@2x.png`, model.bymessika ? model.bymessika[0] : null]}
               alt={`Model ${model.id}`}
            />
         )}
         {model && isExcluBoutique(model) &&
            <span className={`${styles.stars}${addClasses}`}>
               <FontAwesomeIcon icon={faStars} />
            </span>}
         <div>
            <span>
               {model?.id} - {model?.label}
            </span>
            {model && !isHJOModel(model.id) && <span>{formatPPUPrice(minMax.min)}</span>}
         </div>
      </button>
   );
})

export default CardModel;
